import { withChildren } from '@builder.io/react';
import { createBuilderModule } from '../../../builder';
import { withTracking } from '../../../observability';
import { CustomCTAFilled } from './CustomCTAFilled';

export default createBuilderModule(
  withChildren(
    withTracking(CustomCTAFilled, { sectionName: 'CustomCTAFilled' }),
  ),
  {
    name: 'CustomCTAFilled',
    inputs: [
      {
        name: 'heading',
        type: 'string',
        required: true,
      },
      {
        name: 'description',
        type: 'richText',
      },
      {
        name: 'link',
        type: 'object',
        subFields: [
          {
            name: 'text',
            type: 'string',
          },
          {
            name: 'url',
            friendlyName: 'URL',
            type: 'string',
          },
        ],
      },
      {
        name: 'backgroundColor',
        type: 'string',
        enum: ['peach', 'lavender', 'bolt', 'sky', 'cream'],
        defaultValue: 'peach',
      },
    ],
  },
);
